export enum UrlParam {
	SEARCH_KEY = 'q',
	SORT_KEY = 'sort',
	PAGE_KEY = 'page',
	PAGE_SIZE_KEY = 'size',
	REGION_KEY = 'region',
	SURPLUS_KEY = 'surplus',
	UNAVAILABLE_KEY = 'unavailable',
	VARIETY_ID_KEY = 'varietyid',
	VIEW_KEY = 'view',
}
